module.exports = __webpack_public_path__ + "static/media/29EUNOG4.0a552f67.jpg";